import { Injector, NgZone } from '@angular/core';
import {
  AbstractPusherConfigService,
  PusherClientService,
  ServerEventsProviderImpl,
  ServerEventsProviderMock,
  ServerEventsProviderService,
} from '../../services';

export function serverEventsProviderFactory(injector: Injector): ServerEventsProviderService {
  const pusherConfigService = injector.get(AbstractPusherConfigService);

  if (pusherConfigService.getConfig()) {
    return new ServerEventsProviderImpl(injector.get(PusherClientService), pusherConfigService);
  }

  return new ServerEventsProviderMock(injector.get(NgZone));
}
